import { render, staticRenderFns } from "./BizInvoiceinfoForm.vue?vue&type=template&id=7945e258&"
import script from "./BizInvoiceinfoForm.vue?vue&type=script&lang=js&"
export * from "./BizInvoiceinfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports